export default __webpack_public_path__ + "static/reason_1-d39b448d870a48035a48fe4873535b27.png";